import { Routes, Route, Navigate } from "react-router-dom";
import { QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "sonner";
import { AuthProvider } from "./auth/AuthContext";
import { useTheme } from "./theme/ThemeContext";
import { AuthGuard } from "./auth/AuthGuard";
import { AppLayout } from "./components/AppLayout";
import { Login } from "./pages/Login";
import { Dashboard } from "./pages/Dashboard";
import { CustomersList } from "./pages/Customers/List";
import { CustomerDetail } from "./pages/Customers/Detail";
import { LicensesList } from "./pages/Licenses/List";
import { LicenseDetail } from "./pages/Licenses/Detail";
import { AdminsPage } from "./pages/Admins";
import { CellsList } from "./pages/Cells/List";
import { CellDetail } from "./pages/Cells/Detail";
import { SpecsList } from "./pages/Specs/List";
import { SpecDetail } from "./pages/Specs/Detail";
import { ReleasesPage } from "./pages/Releases";
import { createQueryClient } from "./api/queryClient";

// QueryClient ausserhalb der Komponente — Single Instance pro App-Lifetime.
const queryClient = createQueryClient();

export function App() {
  const { theme } = useTheme();
  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <Toaster theme={theme} position="top-right" richColors />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route element={<AuthGuard />}>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/customers" element={<CustomersList />} />
              <Route path="/customers/:id" element={<CustomerDetail />} />
              <Route path="/licenses" element={<LicensesList />} />
              <Route path="/licenses/:id" element={<LicenseDetail />} />
              {/* #343 Provisionierung */}
              <Route path="/cells" element={<CellsList />} />
              <Route path="/cells/:id" element={<CellDetail />} />
              <Route path="/customer-specs" element={<SpecsList />} />
              <Route path="/customer-specs/:id" element={<SpecDetail />} />
              <Route path="/releases" element={<ReleasesPage />} />
              <Route path="/admins" element={<AdminsPage />} />
            </Route>
          </Route>
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </AuthProvider>
    </QueryClientProvider>
  );
}
